import { Typography, Button } from "@material-ui/core";
import { Grid } from "@material/react-layout-grid";
import { BPagoStyle } from "./BPagosStyles";
import BotonIcon from "./../../../global/BotonIcon";
import ClearTwoToneIcon from "@material-ui/icons/ClearTwoTone";
import { useDispatch } from "react-redux";
import { obtenerPagosMasivosAction } from "../../../ducks/pagosMasivosDuck";
import BackDrop from "../../../global/BackDrop";
import { useState } from "react";
import PickerMod from "../../../global/PickersMod";
import { FormatoFecha } from "../../../utils/FormatFecha";

const BPago = () => {
  const dispatch = useDispatch();
  const classes = BPagoStyle();
  const [load, setIsLoad] = useState(false);
  const [selectDayInicio, setSelectedDateInicio] = useState(new Date());
  const [selectDayFin, setSelectedDateFin] = useState(new Date());
  const onClear = () => {
    setIsLoad(true);
    setSelectedDateInicio(new Date());
    setSelectedDateFin(new Date());
    dispatch(
      obtenerPagosMasivosAction(FormatoFecha({ date: new Date(), formato: "dd-MM-yyyy" })
        , FormatoFecha({ date: new Date(), formato: "dd-MM-yyyy" })
      )
    ).then(Response => {
      setIsLoad(false);
    });
  };

  const onBusacar = () => {
    setIsLoad(true);
    dispatch(
      obtenerPagosMasivosAction(
        FormatoFecha({ date: selectDayInicio, formato: "dd-MM-yyyy" }),
        FormatoFecha({ date: selectDayFin, formato: "dd-MM-yyyy" })
      )
    ).then(Response => {
      setIsLoad(false);
    });
  }

  return (
    <Grid className={classes.containerSpacing}>
      <Grid item xs={12} className={classes.modalBotones}>
        <Typography variant="subtitle1">
          Busqueda
        </Typography>
        <BotonIcon title="Limpiar" onClick={onClear}>
          <ClearTwoToneIcon />
        </BotonIcon>
      </Grid>
      <Grid item xs={12}>
        <div style={{paddingRight: "35px"}}>
        <PickerMod
          id="desde"
          label="Desde"
          selectedDate={selectDayInicio}
          setSelectedDate={setSelectedDateInicio}
          disablePast={false}
          disableFuture={true}
        />
        </div>

      </Grid>
      <Grid item xs={12}>
      <div style={{paddingRight: "35px"}}>
      <PickerMod
          id="hasta"
          label="Hasta"
          selectedDate={selectDayFin}
          setSelectedDate={setSelectedDateFin}
          disablePast={false}
          disableFuture={true}
        />
      </div>

      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBoton}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.modalBoton}
            onClick={onBusacar}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={load} />
    </Grid>
  );
};
export default BPago;
